export const SUBMIT_STATES = {
  notSubmitted: 'not_submitted',
  submitLoading: 'submit_loading',
  submitted: 'submitted',
  submitFailed: 'submit_failed',
};
